import { render, staticRenderFns } from "./ConfirmIconButtons.component.vue?vue&type=template&id=5844d142&scoped=true&"
import script from "./ConfirmIconButtons.component.vue?vue&type=script&lang=js&"
export * from "./ConfirmIconButtons.component.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmIconButtons.component.vue?vue&type=style&index=0&id=5844d142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844d142",
  null
  
)

export default component.exports